
import Card from '../../../components/base/Card';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Coaching Personnel',
      description: 'Entraînement personnalisé adapté à vos objectifs et votre niveau',
      features: ['Programme sur mesure', 'Suivi personnalisé', 'Motivation constante']
    },
    {
      icon: 'ri-team-line',
      title: 'Cours en Groupe',
      description: 'Séances collectives pour plus de motivation et de convivialité',
      features: ['Ambiance dynamique', 'Tarifs avantageux', 'Émulation de groupe']
    },
    {
      icon: 'ri-apple-line',
      title: 'Nutrition',
      description: 'Conseils nutritionnels pour optimiser vos résultats',
      features: ['Plans alimentaires', 'Conseils experts', 'Suivi diététique']
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Suivi Digital',
      description: 'Application mobile pour suivre vos progrès en temps réel',
      features: ['Statistiques détaillées', 'Objectifs personnalisés', 'Rappels automatiques']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Nos services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une gamme complète de services pour vous accompagner dans votre transformation physique
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
